export default {
  name: "lea-edit-table-input",
  inject: ["pa", "rules"],
  props: {
    prop: String,
    // v-model绑定的值
    // value: {
    //   type: String,
    //   default: ""
    // },
    // 输入框类型
    type: {
      type: String,
      default: "text"
    },
    data: Object,
    // 下拉框数据
    selectList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      index: -1,
      text: "",
      inputVal: ""
      // form: {
      //   inputVal: ""
      // }
    };
  },
  computed: {
    // 父节点
    owner() {
      let parent = this.$parent;

      while (parent && !parent.tableFlag) {
        parent = parent.$parent;
      }

      if (parent) {
        throw new Error("can not find root: lea-edit-table");
      }

      return parent;
    },
    // 表单值
    input() {
      return this.data.row[this.prop];
    },
    // 是否可编辑
    editable() {
      return this.data.row["editable"];
    },
    // 是否选项类别
    isList() {
      return this.type === "select" || this.type === "radio";
    }
  },
  watch: {
    inputVal(val) {
      let index = this.data.index;
      let prop = this.prop;
      let value = val;
      this.$bus.$emit("on-change-cell", { prop, index, value });
    },
    "data.row.editable"(editable) {
      // console.log(this.owner)
      // console.log(this.data.index)
      // console.log(this.data.row)
      // console.log(this.prop)
      // console.log(this.data.row[this.prop])

      if (editable) {
        this.inputVal = this.data.row[this.prop];
      }
    }
  },
  render(h) {
    // 展示状态
    if (!this.editable) {
      return this.renderText(h);
    }

    // 表单状态
    return this.renderForm(h);
  },
  methods: {
    // 转换
    formatText(text) {
      // 非空验证
      let isTextNull = true;
      let textType = typeof text;
      if (textType === "string") {
        isTextNull = text.length === 0;
      } else if (textType === "number") {
        // todo
        isTextNull = false;
      } else {
        throw new Error("值只能是数字或字母");
      }

      if (isTextNull) return "";

      if (!this.data.row["editable"] && this.isList) {
        let filterArr = this.selectList.filter(item => item.value === text);
        text = filterArr.length === 0 ? "" : filterArr[0]["label"];
      }

      return text;
    },

    // 渲染文本
    renderText(h) {
      let innerText = this.formatText(this.input);
      return h("span", { domProps: { innerText } });
    },

    // 渲染表单
    renderForm() {
      let size = "mini";
      let clearable = true;

      // 子节点
      let child = null;
      // console.log(this.inputVal)

      if (this.type === "text") {
        // text
        child = (
          <el-input v-model={this.inputVal} size={size} clearable={clearable} />
        );
      } else if (this.type === "select") {
        // select
        child = (
          <el-select v-model={this.inputVal} size={size} clearable={clearable}>
            {this.selectList.map(item => {
              return (
                <el-option
                  key={item.value}
                  label={item.label}
                  value={item.value}
                />
              );
            })}
          </el-select>
        );
      } else if (this.type === "radio") {
        // radio
        child = (
          <el-radio-group
            v-model={this.inputVal}
            size={size}
            clearable={clearable}
          >
            {this.selectList.map(item => {
              return (
                <el-radio
                  key={item.value}
                  label={item.label}
                  value={item.value}
                >
                  {item.label}
                </el-radio>
              );
            })}
          </el-radio-group>
        );
      }

      return (
        <el-form>
          <el-form-item label="">{child}</el-form-item>
        </el-form>
      );
    }
  },
  updated() {
    this.index = this.data.index;
  }
};
